import {FC, useState} from 'react'
import {CsvRow, DataMap, UploadPayload, UploadStep} from '..'
import UploadContactFooter from '../Element/UploadContactFooter'
import MapData from './MapData'


export type InputMappingProps = {
  csvData: CsvRow[]
  mapped: DataMap[]
  setMapped: (data: DataMap[]) => void
  handleClose: () => void
  setActiveState: (state: UploadStep) => void
  handleNext: () => void
}

const InputMapping: FC<InputMappingProps> = (props) => {
  const {
    mapped,
    csvData,
    handleClose,
    handleNext,
    setActiveState,
    setMapped,
  } = props


  return (
    <div className='modal-body px-20'>
      <MapData data={csvData} mapped={mapped} setMapped={setMapped} />
      <UploadContactFooter
        allowedNext={true}
        handleClose={handleClose}
        handleNext={handleNext}
        handleBack={() => setActiveState(UploadStep.Input)}
      />
    </div>
  )
}

export default InputMapping
